import { create } from 'zustand';
import { recentSearches } from './recentSearches';

// Ported from pinned build58 continuationArtist.ts. Source IDs are not local DB IDs.
const normalize = (value) => value.trim().normalize('NFKC').toLocaleLowerCase();
export function searchArtistIdentity(artist) {
  return {
    name: artist.name,
    sourceId: artist.id == null ? undefined : String(artist.id),
    artistSource: artist.artistSource,
    id: artist.artistId,
    slug: artist.artistId != null ? artist.slug : undefined,
    imageUrl: artist.artistImageUrl ?? artist.imageUrl,
  };
}
export function selectContinuationArtist({ query, selected, results, fallback }) {
  if (selected) return selected;
  const albums = results?.albums?.items ?? [];
  const exact = albums.find((album) => normalize(album.title) === normalize(query))?.artist;
  if (exact) return exact;
  const first = results?.artists?.items[0];
  return first ? searchArtistIdentity(first) : (albums[0]?.artist ?? fallback ?? undefined);
}
export function matchContinuationProfile(identity, artists) {
  if (!identity) return undefined;
  return artists.find((artist) =>
    identity.sourceId
      ? String(artist.id ?? '') === identity.sourceId &&
        (!identity.artistSource ||
          !artist.artistSource ||
          artist.artistSource === identity.artistSource)
      : identity.id != null && artist.artistId != null
        ? identity.id === artist.artistId
        : normalize(artist.name) === normalize(identity.name),
  );
}
export const useSearchContinuation = create((set) => ({
  selection: null,
  select: (selection) => set({ selection }),
}));
export function selectedArtistFor(selection, scope, query) {
  return selection?.scope === String(scope ?? 'guest') &&
    selection.query.toLocaleLowerCase() === query.trim().toLocaleLowerCase()
    ? selection.artist
    : undefined;
}
export function rememberSearchSelection(kind, item, query, scope) {
  const term = query?.trim();
  if (!term) return;
  const artist =
    kind === 'artist' ? searchArtistIdentity(item) : kind === 'album' ? item.artist : undefined;
  if (artist)
    useSearchContinuation
      .getState()
      .select({ scope: String(scope ?? 'guest'), query: term, artist });
  recentSearches.add(term);
}
